import { useCallback } from 'react';
import { useGadgetAdditionalStateActions } from '@atlassian/jira-dashboard-internal-common/src/controllers/gadget-additional-state.tsx';
import { lensGadgetsList } from '@atlassian/jira-dashboard-internal-common/src/utils/dashboard-config-lenses/index.tsx';
import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { useFlagService, type Flag } from '@atlassian/jira-flags';
import { useDashboardResource } from '@atlassian/jira-router-resources-dashboard/src/index.tsx';
import { messages } from './messages.tsx';

const deleteSuccessFlag = (name: string): Flag => ({
	type: 'success',
	title: messages.successTitle,
	description: [messages.successDescription, { name }],
	isAutoDismiss: false,
	delayAnnouncement: 1500,
	messageId: 'dashboard-edit.services.flag.success.delete-success-flag',
	messageType: 'transactional',
});

const deleteFailureFlag: Flag = {
	type: 'error',
	title: messages.failureTitle,
	description: messages.failureDescription,
	isAutoDismiss: false,
	delayAnnouncement: 1500,
	messageId: 'dashboard-edit.services.delete-failure-flag.error',
	messageType: 'transactional',
};

export const useDeleteGadget = (id: string, name: string) => {
	const { data, update } = useDashboardResource();
	const [, { remove }] = useGadgetAdditionalStateActions();
	const flagService = useFlagService();

	return useCallback(async () => {
		if (!data) {
			return;
		}
		const gadgetUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}`;
		try {
			await performDeleteRequest(gadgetUrl);
			update(lensGadgetsList((gadgets) => gadgets.filter((element) => element.id !== id)));
			remove(id);
			flagService.showFlag(deleteSuccessFlag(name));
		} catch (_) {
			flagService.showFlag(deleteFailureFlag);
		}
	}, [data, id, update, remove, flagService, name]);
};
